import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import useAuth from "../../../../../hooks/useAuth";
import ProjectFilter from "../../../../../layouts/ShoppingLayout/ProjectFilter";
import { ShoppingProvider } from "../../../../../contexts/shopping";
import KitComponents from "../../../../../components/TablePro/components/assets/AddComponent/KitComponents";

export default function AddComponentModal({ onClose, projectId: defaultProjectId }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const wizardMode = settings?.wizard_mode;
  const simpleCheckoutForContractWarehouse = settings?.simple_checkout_for_contract_warehouse;
  const isExtendedCheckout = wizardMode || simpleCheckoutForContractWarehouse;
  const [projectId, setProjectId] = useState(isExtendedCheckout ? undefined : defaultProjectId);

  const onSelectProject = id => {
    setProjectId(id);
  };

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      aria-labelledby="dialog-title"
      PaperProps={{ sx: { maxWidth: "850px" } }}
    >
      <DialogTitle id="dialog-title" sx={{ position: "relative", pb: isExtendedCheckout ? 1 : 2 }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
        <Box display="flex" justifyContent="center">
          <Typography
            variant="h5"
            color="textPrimary"
            component="span"
            textAlign="center"
            sx={{ fontSize: 24 }}
          >
            Add Kit Components
          </Typography>
        </Box>
        {isExtendedCheckout && (
          <Grid container spacing={1} mt={1}>
            <Grid size={12}>
              <Box display="flex" alignItems="center" justifyContent="center" gap={1.5}>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                >
                  <Typography variant="body1" color="textPrimary">
                    Choose a {settings.filter_field2}
                  </Typography>
                  <Typography></Typography>
                </Breadcrumbs>
                <Box width="300px">
                  <ProjectFilter
                    size="small"
                    projectId={projectId}
                    onSelectProject={onSelectProject}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        )}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <ShoppingProvider>
            <KitComponents
              displayProjectSelector={isExtendedCheckout}
              projectId={projectId}
              variables={{ hideDepletedAssets: false }}
              displayFilters={false}
              cardsPerRow={3}
            />
          </ShoppingProvider>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box display="flex" p={1.5}>
          <Button variant="outlined" onClick={onClose} color="primary">
            Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
